
import { IsUUID, IsNotEmpty } from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'

/**
 * DTO pour la requête de memberships utilisateur
 */
export class GetUserMembershipsDto {
  @ApiProperty({
    type: 'string',
    description: "ID de l'utilisateur",
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  @IsUUID('4', { message: 'userId doit être un UUID v4 valide' })
  @IsNotEmpty({ message: 'userId est requis' })
  userId: string
}
